import React from "react";
import rightArrowIcon from "../../../assets/icons/arrows/chevron-right.svg";
import leftArrowIcon from "../../../assets/icons/arrows/chevron-left.svg";
import "./CalendarHeader.scss";
import Filter from "../../Filter/Filter";
import { apolloClient } from "../../..";
import { gql } from "@apollo/client";

export default class CalendarHeader extends React.Component {
  state = {
    documentTypes: [],
  };

  changeCalendarView = (e) => {
    this.props.updateCalendarView(e.target.name);
  };

  componentDidMount() {
    apolloClient
      .query({
        query: gql`
          query {
            templatesOfCustomer {
              id
              title
              documentSet {
                id
                file
                title
                inTrash
              }
            }
          }
        `,
        variables: {},
      })
      .then((result) => {
        const docTitles = [];
        const docsObj = {};
        result.data.templatesOfCustomer.map((doc) => {
          docTitles.push(doc.title);
          docsObj[doc.title] = doc.documentSet.filter(
            (document) => !document.inTrash
          );
          return true;
        });
        this.setState({
          documentTypes: docTitles,
        });
        this.props.setDocumentTypes(docsObj);
      })
      .catch((e) => {});
  }

  render() {
    return (
      <div className="container-fluid calendar-header-wrapper">
        <div className="row calendar-header">
          <div className="col-6 left-header-part">
            <h3>Calendar</h3>
            <div className="calendar-navigator">
              <img
                src={leftArrowIcon}
                onClick={this.props.goToPrev}
                alt="left-arrow"
              />
              <span className="title">{this.props.calendarHeaderTitle}</span>
              <img
                src={rightArrowIcon}
                onClick={this.props.goToNext}
                alt="right-arrow"
              />
            </div>
          </div>
          <div className="col-6 right-header-part">
            <div
              className="btn-group btn-group-toggle calendar-view-selector mr-3"
              data-toggle="buttons"
            >
              <label
                className={`btn btn-secondary-toggle ${
                  this.props.calendarView === "week" ? "active" : ""
                }`}
              >
                <input
                  type="radio"
                  name="week"
                  checked={this.props.calendarView === "week"}
                  onClick={this.changeCalendarView}
                  readOnly
                />{" "}
                Week
              </label>
              <label
                className={`btn btn-secondary-toggle ${
                  this.props.calendarView === "month" ? "active" : ""
                }`}
              >
                <input
                  type="radio"
                  name="month"
                  checked={this.props.calendarView === "month"}
                  onClick={this.changeCalendarView}
                  readOnly
                />{" "}
                Month
              </label>
              <label
                className={`btn btn-secondary-toggle ${
                  this.props.calendarView === "year" ? "active" : ""
                }`}
              >
                <input
                  type="radio"
                  name="year"
                  checked={this.props.calendarView === "year"}
                  onClick={this.changeCalendarView}
                  readOnly
                />{" "}
                Year
              </label>
            </div>
            <Filter
              calendarView={this.props.calendarView}
              filterApplyHandler={this.props.filterHandler}
              rootFolders={this.props.rootFolders}
              subFolders={this.props.subFolders}
              documentTypes={this.state.documentTypes}
              dateTitles={this.props.dateTitles}
            />
          </div>
        </div>
      </div>
    );
  }
}
